/**
 * Минимальная утилита склейки className. Не используем clsx/classnames в Фазе 1,
 * чтобы не плодить зависимости — ничего сложного нам пока не нужно.
 */
type ClassValue = string | number | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
